import React from "react";
import { ShieldAlert, Shield } from "lucide-react";

/**
 * Reliability pill for V2 surfaces.
 * Colors mirror the FUT-rarity tiers used on V1's SocialCard so the visual
 * language stays consistent across versions.
 *   ≥85  gold    ✦
 *   ≥70  green   (default healthy)
 *   ≥50  amber
 *   <50  red
 * Flagged accounts always render the alert variant in red regardless of score.
 *
 * Sizes:
 *   xs (default) — inline next to a name
 *   sm           — slightly bigger for hero cards
 */
export default function RelPill({ score, flagged = false, size = "xs", testId }) {
  if (score == null) return null;
  const s = Math.max(0, Math.min(100, Math.round(Number(score) || 0)));

  let color = "#10B981";
  let bg = "rgba(16,185,129,0.15)";
  let label = "REL";
  if (flagged) {
    color = "#EF4444"; bg = "rgba(239,68,68,0.16)"; label = "FLAG";
  } else if (s >= 85) {
    color = "#FFD700"; bg = "rgba(255,215,0,0.15)";
  } else if (s >= 70) {
    color = "#10B981"; bg = "rgba(16,185,129,0.15)";
  } else if (s >= 50) {
    color = "#F59E0B"; bg = "rgba(245,158,11,0.18)";
  } else {
    color = "#EF4444"; bg = "rgba(239,68,68,0.16)";
  }

  const cls = size === "sm"
    ? "text-[10px] px-2 py-0.5"
    : "text-[9px] px-1.5 py-0.5";

  const Icon = flagged ? ShieldAlert : Shield;

  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1 rounded-full font-bold tabular-nums tracking-wider ${cls}`}
      style={{ color, backgroundColor: bg }}
      title={flagged ? "Flagged for low reliability" : `Reliability ${s}/100`}
    >
      <Icon className="w-3 h-3" />
      {flagged ? label : s}
    </span>
  );
}
